import { normalizeRecordResponse } from 'api';
import { client } from 'queries';

export const referrerQuery = async ({ req, params, query }) => {
	const formattedParams = { context: query.context ? query.context : ['ssr'] };
	if (!query.referralCode) return {};
	const response = await client.apiRequest({ url: `/referrer/${query.referralCode}`, params: formattedParams });
	return normalizeRecordResponse(response);
};
